import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { Users, Minus, Plus, ChevronDown } from "lucide-react";

const Row = ({ label, hint, value, min, max, onChange, testid }) => (
  <div className="flex items-center justify-between py-2">
    <div><div className="text-sm font-semibold text-slate-700">{label}</div><div className="text-[11px] text-slate-400">{hint}</div></div>
    <div className="flex items-center gap-2">
      <button type="button" data-testid={`${testid}-minus`} disabled={value <= min} onClick={() => onChange(value - 1)} className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:bg-slate-50"><Minus size={13} /></button>
      <span className="w-6 text-center font-bold text-slate-800" data-testid={testid}>{value}</span>
      <button type="button" data-testid={`${testid}-plus`} disabled={value >= max} onClick={() => onChange(value + 1)} className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:bg-slate-50"><Plus size={13} /></button>
    </div>
  </div>
);

// value: { adults, children, infants }
export const PassengerPicker = ({ value, onChange, className = "" }) => {
  const { t } = useApp();
  const p = t.pax;
  const [open, setOpen] = useState(false);
  const total = value.adults + value.children + value.infants;
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="relative">
      <button type="button" data-testid="pax-toggle" onClick={() => setOpen(!open)} className={`${className} text-start flex items-center justify-between gap-2`}>
        <span className="flex items-center gap-2 truncate"><Users size={15} className="text-tigris shrink-0" /> {total} {p.travelers}</span>
        <ChevronDown size={14} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div data-testid="pax-popover" className="absolute z-40 mt-2 w-72 bg-white rounded-2xl shadow-2xl border border-slate-100 p-4 start-0">
            <Row label={p.adults} hint={p.adultsHint} value={value.adults} min={1} max={9 - value.children - value.infants} testid="pax-adults"
              onChange={(v) => set({ adults: v, infants: Math.min(value.infants, v) })} />
            <Row label={p.children} hint={p.childrenHint} value={value.children} min={0} max={9 - value.adults - value.infants} testid="pax-children" onChange={(v) => set({ children: v })} />
            <Row label={p.infants} hint={p.infantsHint} value={value.infants} min={0} max={Math.min(value.adults, 9 - value.adults - value.children)} testid="pax-infants" onChange={(v) => set({ infants: v })} />
            <p className="text-[11px] text-slate-400 mt-2 border-t border-slate-100 pt-2">{p.policy}</p>
            <button type="button" data-testid="pax-done" onClick={() => setOpen(false)} className="btn-primary w-full mt-3 py-2 rounded-lg text-sm font-bold">{p.done}</button>
          </div>
        </>
      )}
    </div>
  );
};

export const paxLabel = (f, p) => [`${f.adults} ${p.adultsShort}`, f.children ? `${f.children} ${p.childrenShort}` : null, f.infants ? `${f.infants} ${p.infantsShort}` : null].filter(Boolean).join(" · ");
